import React, { useContext, useState, useEffect } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { colors } from "../context/Colors";
import AppContext from "../context";
import Icon from "react-native-vector-icons/Ionicons";
import { useColorScheme } from "react-native-appearance";
import { useNavigation } from "@react-navigation/native";
import { DraggableGrid } from "react-native-draggable-grid";
import Puzzle from "../components/Puzzle";

export default function JigsawPuzzle() {
  const navigation = useNavigation();
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, setTour, setGameMenuHeight, dict } = useContext(AppContext);
  const [size, setSize] = useState(70);

  useEffect(() => {
    tour.badgePuzzle = 0;
    setTour({ ...tour });
  }, []);

  return (
    <View
      style={{
        padding: 10,
        borderRadius: 10,
      }}
      onLayout={(e) => {
        // console.log('LAYOUT');
        setGameMenuHeight(e.nativeEvent.layout.height);
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TouchableOpacity
          style={{ padding: 10, marginLeft: -10 }}
          onPress={() => navigation.goBack()}
        >
          <Icon name="chevron-back" color={colors[theme].text} size={22} />
        </TouchableOpacity>
        <Text
          style={{
            color: colors[theme].text,
            fontSize: 19,
            fontWeight: "600",
            flex: 1,
            textAlign: "center",
          }}
        >
          {dict.jigsaw_puzzle}
        </Text>

        <View style={{ width: 34 }} />
      </View>
      <View
        style={{
          height: Math.ceil(tour.puzzles.length / 4) * size + 24,
          borderRadius: 10,
          padding: 10,
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 0,
          },
          shadowOpacity: 0.1,
          shadowRadius: 6.27,
          elevation: 4,
          backgroundColor: colors[theme].bg,
          marginBottom: 10,
          maxWidth: 800,
        }}
        onLayout={(e) => {
          // console.log(e.nativeEvent.layout.width);
          setSize(e.nativeEvent.layout.width / 4 - 7);
        }}
        id="jigsaw"
      >
        <DraggableGrid
          numColumns={4}
          renderItem={(item) => (
            <View key={item.key}>
              <Puzzle l={item.objectBlobReference} size={size} />
            </View>
          )}
          data={tour.puzzles}
          onDragRelease={(data) => setTour({ ...tour, puzzles: data })}
          disabledResorted={true}
        />
      </View>
      <Text
        style={{
          color: colors[theme].text,
          fontSize: 18,
          fontWeight: "600",
          margin: 10,
        }}
      >
        {dict.press_drag}
      </Text>

      <View
        style={{
          borderWidth: 2,
          borderColor: colors[theme].gamePreamble,
          flexDirection: "row",
          marginTop: 10,
          marginHorizontal: 5,
          alignItems: "center",
          borderRadius: 8,
          backgroundColor: colors[theme].gamePreamble,
        }}
      >
        <View
          style={{
            backgroundColor: colors[theme].bg,
            padding: 8,
            marginRight: 10,
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
          }}
        >
          <Icon
            name="information-circle-outline"
            size={24}
            color={colors[theme].text}
            style={{ opacity: 0.4 }}
          />
        </View>
        <Text
          style={{
            color: colors[theme].text,
            opacity: 0.4,
            fontSize: 12,
            fontWeight: "600",
            marginRight: 80,
          }}
        >
          {dict.puzzle_clues}
        </Text>
      </View>
    </View>
  );
}
